import React, { useEffect, useRef, useState } from "react"
import dayjs from "dayjs"
// import { ReactFullYearScheduler } from "react-full-year-scheduler"
import "react-full-year-scheduler/dist/style.css"
import axios from 'axios'
import Select from "react-select"
import QRCode from 'qrcode'
import moment from 'moment'
import { Helmet } from "react-helmet"
import '../Dashboard.css'

import Header from "../components/Header"
import Footer from "../components/Footer"
import ScrollToTop from "../components/ScrollTop"
import PreloadFetch from "../components/PreloadFetch"

import { ImCheckmark, ImCross, ImCalendar } from "react-icons/im"
import { useAuth } from '../provider/authProvider'
import { Link, useNavigate, useParams } from "react-router-dom"
import { ToastContainer, toast } from 'react-toastify'


const returnDateFormat = (dateOne) => {
    let splitDate = dateOne.split('/')
    let rebuildDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]

    return rebuildDate
}

const returnDateFormatTwo = (dateOne) => {
    let splitDate = dateOne.split('-')
    let rebuildDate = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0]

    return rebuildDate
}


function CreditPage(props) {

    const { user } = useAuth()

    const navigate = useNavigate()

    const [userRole, setUserRole] = useState(0)

    const getParams = useParams()

    const [listCreditData, setListCreditData] = useState()

    const [listCreditDataLocation, setListCreditDataLocation] = useState()

    const [daysPayment, setDaysPayment] = useState()

    const [daysPaymentTwo, setDaysPaymentTwo] = useState()

    const [events, setEvents] = useState([])

    const [blockConfirmPay, setBlockConfirmPay] = useState(false)

    const [confirmPay, setConfirmPay] = useState(false)

    const [currentDate, setCurrentDate] = useState()

    const [preload, setPreload] = useState(false)

    const [stateDevice, setStateDevice] = useState(false)

    const [unlockCode, setUnlockCode] = useState('')

    const [allpayState, setAllpayState] = useState(false)

    const [urlQrCode, setUrlQrCode] = useState()

    const [structureCalendar, setStructureCalendar] = useState(-1)

    const [wrapDaysPayment, setWrapDaysPayment] = useState()

    const [payNow, setPayNow] = useState(0)

    const [dataNumbers, setDataNumbers] = useState()

    const [resumePayment, setResumePayment] = useState([])

    const [feeCount, setFeeCount] = useState(0)
    const [feePay, setFeePay] = useState(0)
    const [feeExpire, setFeeExpire] = useState(0)
    const [feePending, setFeePending] = useState(0)
    const [feePendingTotal, setFeePendingTotal] = useState(0)

    const [stateBlockDevice, setStateBlockDevice] = useState(null)
    const [stateFilter, setStateFilter] = useState(null)

    const [uploadName, setUploadName] = useState(null)

    const [uploadNameCartaCobranza, setUploadNameCartaCobranza] = useState(null)

    const [cobranzasUsers, setCobranzasUsers] = useState([])
    const [cobranzasSelected, setCobranzasSelected] = useState(null)
    const [cobranzasLocked, setCobranzasLocked] = useState(false)
    const [loadingCobranzasUsers, setLoadingCobranzasUsers] = useState(false)


    // const [uploadNameConstanciaNoAdeudo, setUploadNameConstanciaNoAdeudo] = useState(null)

    const [cartaCobranzaState, setCartaCobranzaState] = useState(false)

    const [cartaConstanciaState, setCartaConstanciaState] = useState(false)

    const [blockResquedulePay, setBlockResquedulePay] = useState(false)

    const [dayResquedule, setDayResquedule] = useState()

    const [selectClassName, setSelectClassName] = useState(-1)

    const refChangeNum = useRef()

    const refChangeNumTwo = useRef()

    const resqueduleNumFeeRef = useRef()

    const [resqueduleNumFee, setResqueduleNumFee] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9])

    const [countPaymentFalse, setCountPaymentFalse] = useState([])

    const [listResPayments, setListResPayments] = useState([])

    const changeDate = (date) => {
        let firtsPaymentTransformOne = date.split('/')
        let constructDate = firtsPaymentTransformOne[2] + '-' + firtsPaymentTransformOne[1] + '-' + firtsPaymentTransformOne[0]
        return constructDate
    }


    const getCobranzasUsers = async () => {
        try {
            setLoadingCobranzasUsers(true)
            const resp = await axios({
                method: 'get',
                url: process.env.REACT_APP_API + '/users/by-role/4',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            })
            const resData = resp.data
            if (resData?.msg === 'success') {
                const options = (resData.data || []).map(u => ({
                    value: u.id,
                    label: u.fullName
                }))
                setCobranzasUsers(options)
            } else {
                setCobranzasUsers([])
            }
        } catch (err) {
            console.log(err)
            setCobranzasUsers([])
        } finally {
            setLoadingCobranzasUsers(false)
        }
    }

    const assignCobranzasUser = async (option) => {
        if (!option || cobranzasLocked) return
        try {
            setPreload(true)
            const resp = await axios({
                method: 'post',
                url: process.env.REACT_APP_API + '/credit/' + getParams.id + '/assign-cobranzas',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { userId: option.value }
            })
            const resData = resp.data
            if (resData?.msg === 'success') {
                setCobranzasSelected(option)
                setCobranzasLocked(true)
                // Mantener sincronizado el crédito en pantalla
                setListCreditData((prev) => prev ? ({
                    ...prev,
                    cobranzaUserId: option.value,
                    cobranzaUserName: option.label
                }) : prev)
            } else if (resData?.msg === 'already_assigned') {
                // ya estaba asignado; bloquear UI
                setCobranzasSelected(option)
                setCobranzasLocked(true)
            } else {
                alert(resData?.msg || 'No se pudo asignar el responsable de cobranzas.')
            }
        } catch (err) {
            console.log(err)
            alert('Error al asignar el responsable de cobranzas.')
        } finally {
            setPreload(false)
        }
    }

    const getCreditData = async () => {
        try {
            setPreload(true)
            const credits = await axios({
                method: 'get',
                url: process.env.REACT_APP_API + '/credit/' + getParams.id,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            })
            const resData = credits.data
            // console.log(resData.userRole);
            setUserRole(resData.userRole)
            setListCreditData(resData.data[0])

            // Responsable de Créditos y Cobranzas (solo se selecciona 1 vez)
            const cobranzaId = resData.data[0]?.cobranzaUserId
            const cobranzaName = resData.data[0]?.cobranzaUserName
            if (cobranzaId && cobranzaName) {
                setCobranzasSelected({ value: cobranzaId, label: cobranzaName })
                setCobranzasLocked(true)
            } else {
                setCobranzasSelected(null)
                setCobranzasLocked(false)
            }

            setListCreditDataLocation(resData.locationData[0])

            setDaysPayment(resData.data[0] ? resData.data[0].daysPayment : '')
            setDaysPaymentTwo(resData.data[0] ? resData.data[0].daysPaymentTwo : '')
            setWrapDaysPayment(resData.data[0] ? resData.data[0].daysPayment : '')

            setDataNumbers(resData.dataNumbers)
            setResumePayment(resData.resumePayment)

            let dataWeekPay = JSON.parse(resData.data[0].daysPayment)

            setFeeCount(dataWeekPay.length)
            let feePay = dataWeekPay.filter(item => item.state == 1)
            let feeNotPay = dataWeekPay.filter(item => item.state == 0)

            //-----
            let arrFeeNotPay = []
            for (let i = 1; i <= feeNotPay.length; i++) {
                arrFeeNotPay.push(i)
            }
            setCountPaymentFalse(arrFeeNotPay)
            //-----

            let feeExpireData = dataWeekPay.filter(item => moment(moment()).isAfter(moment(changeDate(item.date))) && item.state == 0)
            let feePendingData = dataWeekPay.filter(item => moment(moment()).isBefore(moment(changeDate(item.date))) && item.state == 0)
            let feePendingTotalData = dataWeekPay.filter(item => item.state == 0)
            // console.log('frankkkk')
            // console.log(feeExpireData)
            // console.log(dataWeekPay)  
            setFeePay(feePay.length)
            setFeeExpire(feeExpireData.length)
            setFeePending(feePendingData.length)

            setFeePendingTotal(feePendingTotalData.length)

            setUploadName('https://infos.movilespay.com/data-files/' + resData.data[0].uploadName + '/constancia-no-adeudo.pdf')
            setUploadNameCartaCobranza('https://infos.movilespay.com/data-files/' + resData.data[0].uploadName + '/carta-de-cobranza.pdf')

            setListResPayments(resData.resPayments)
            // if (structureCalendar == '0') {
            //     // setWrapDaysPayment(daysPayment)
            //     setWrapDaysPayment(resData.data[0] ? resData.data[0].daysPayment : '')
            //     // setWrapDaysPayment(resData.data[0] ? resData.data[0].daysPaymentTwo : '')
            // }
            // console.log(JSON.parse(resData.data[0].daysPayment))
            if (resData.data[0]) {
                setStateBlockDevice(resData.data[0].stateBlockDevice)
                setStateFilter(resData.data[0].stateFilter)
                // console.log(resData.data[0].stateFilter)
                // let getPayNow = JSON.parse(resData.data[0].daysPaymentTwo).filter((item) => {
                //     // console.log(item.date)
                //     // if (item.id !== 0) {
                //         // return item.date <= moment().format("YYYY-MM-DD")
                //     return item.state === 0 &&
                //         moment(returnDateFormat(item.date)).isSame(moment().format("YYYY-MM-DD"))
                //         || moment(moment().format("YYYY-MM-DD")).isAfter(returnDateFormat(item.date))
                //     // }
                // })

                // console.log(JSON.parse(resData.data[0].daysPayment))
                let getPayNow = JSON.parse(resData.data[0].daysPaymentTwo).filter((item) => {
                    // console.log(item.date)
                    // if (item.id !== 0) {
                    // return item.date <= moment().format("YYYY-MM-DD")
                    return item.state === 0 && moment(returnDateFormat(item.date)).isAfter(moment().format("YYYY-MM-DD"))
                    // }
                })
                let getPayNowTwo = JSON.parse(resData.data[0].daysPaymentTwo).filter((item) => {
                    // console.log(item.date)
                    // if (item.id !== 0) {
                    // return item.date <= moment().format("YYYY-MM-DD")
                    return item.state === 0
                    // }
                })
                let getPayLate = JSON.parse(resData.data[0].daysPaymentTwo).filter((item) => {
                    // console.log(item.date)
                    // if (item.id !== 0) {
                    // return item.date <= moment().format("YYYY-MM-DD")
                    return item.state === 0 && moment(returnDateFormat(item.date)).isBefore(moment().format("YYYY-MM-DD")) || moment(returnDateFormat(item.date)).isSame(moment().format("YYYY-MM-DD"))
                    // }
                })
                // console.log(getPayNow)
                let comision = JSON.parse(resData.data[0].daysPayment)[1] ? JSON.parse(resData.data[0].daysPayment)[1].comision : 0
                let getComision = parseFloat(comision)
                let numFee = resData.data[0].numFee
                let totalComision = getComision * numFee

                // console.log(getPayNow)
                if (getPayNowTwo.length > 0) {
                    // console.log(getPayNow)
                    let arrCuotaFinal = []
                    let arrComision = []
                    let arrComisionXtiempo = []
                    let arrPayLate = []

                    getPayNowTwo.forEach((item) => {
                        // console.log(item)
                        if (item.state === 0) {
                            arrCuotaFinal.push(item.cuota_final)
                            arrComision.push(item.comision)
                            arrComisionXtiempo.push(item.comision_x_tiempo)
                        }
                    })
                    // console.log(getPayNowTwo)
                    // console.log(getPayLate.length)

                    if (getPayLate && getPayLate.length > 0) {
                        getPayLate.forEach((item) => {
                            // console.log(item)
                            if (item.state === 0) {
                                arrPayLate.push(item.comision_x_tiempo)
                            }
                        })
                    }
                    // console.log(getPayLate)
                    // console.log(arrCuotaFinal)
                    // console.log(arrComision)

                    let sumCuotaFinal = arrCuotaFinal.reduce((sum, num) => parseFloat(sum) + parseFloat(num), 0)
                    let sumComision = arrComision.reduce((sum, num) => parseFloat(sum) + parseFloat(num), 0)
                    let sumComisionXtiempo = arrComisionXtiempo.reduce((sum, num) => parseFloat(sum) + parseFloat(num), 0)
                    let totalInteres = sumCuotaFinal - sumComision
                    let sumPayLate = arrPayLate.reduce((sum, num) => parseFloat(sum) + parseFloat(num), 0)
                    // console.log('sumpaylate')
                    // console.log(sumPayLate)
                    // console.log(totalInteres)
                    // console.log(arrPayLate.length)
                    // let getTotalPay = parseFloat(getPayNow[getPayNow.length - 1].saldo) + parseFloat(totalComision) + parseFloat(totalInteres)
                    let getTotalPay = parseFloat(getPayNowTwo[0].saldo) + sumComision + sumPayLate
                    // console.log(sumCuotaFinal, sumComision, totalInteres)
                    // console.log(getTotalPay)
                    setPayNow(parseFloat(getTotalPay).toFixed(2))
                } else {
                    // let comision = JSON.parse(resData.data[0].daysPayment)[0].comision
                    // let numFee = listCreditData.numFee
                    // console.log('hola')

                    let restFinancing = JSON.parse(resData.data[0].daysPaymentTwo).filter((item) => {
                        // console.log(item.date)
                        // if (item.id !== 0) {
                        // return item.date <= moment().format("YYYY-MM-DD")
                        return item.state === 0 &&
                            moment(returnDateFormat(item.date)).format() >= moment().format()
                    })

                    let payFinancing = JSON.parse(resData.data[0].daysPaymentTwo).filter((item) => { // obtenemos toda las comision pagada para poder restar
                        // console.log(item.date)
                        // if (item.id !== 0) {
                        // return item.date <= moment().format("YYYY-MM-DD")
                        return item.state === 1
                    })
                    // console.log(payFinancing)

                    // let amf = parseFloat(resData.data[0].amountFinance) // amount finance
                    let currentComision = restFinancing[0] ? parseFloat(restFinancing[0].comision) : 0
                    let amf = restFinancing[0] ? parseFloat(restFinancing[0].saldo) + parseFloat(currentComision) : 0 // resta del credito
                    let ttc = parseFloat(totalComision) // total comision
                    // console.log(ttc)
                    let ttctotal = parseFloat(amf) + parseFloat(ttc) // float total comision
                    setPayNow(parseFloat(ttctotal).toFixed(2))
                }
                // console.log(getPayNow)
            }

            let qrConvert = await generateQR(JSON.stringify(resData.data[0].qrCode))
            setUrlQrCode(qrConvert)
            setPreload(false)

            // setStateDevice(resData.data[0].stateBlockDevice == 1 ? true : false)
        } catch (err) {
            console.log(err)
            return false
        }
    }

    const changeEventsCalendar = () => {
        if (daysPayment) {
            let newArr = []
            let newObjFunc = (index, date, status) => {
                return {
                    eventName: "Pago " + index,
                    startDate: dayjs(date),
                    endDate: dayjs(date),
                    eventBgColor: status == 0 ? "#ff0000" : '#198754',
                    eventTextColor: "white"
                }
            }
            if (daysPayment) {
                JSON.parse(daysPayment).forEach((item, index) => {
                    // console.log(item.date)
                    return newArr.push(newObjFunc(index + 1, item.date, item.state))
                })
                setEvents(newArr)
            }
        }
    }

    const confirmChangePay = async () => {
        if (!confirmPay) {
            alert('Hace falta su confirmación de pagó')
            return false
        }

        let confirm = window.confirm('¿Confirmar Pago?')
        let newIndex = 0
        // console.log(daysPayment)
        // return false
        if (confirm) {
            let newDaysPayment = JSON.parse(daysPayment).map((item, index) => {
                // if (item.id !== 0) {
                if (item.state === 1) {
                    item.state = 1
                } else if (item.state === 0) {
                    // console.log('item up')
                    // console.log(item, currentDate[index])
                    // console.log('item.')
                    // console.log(JSON.stringify(item))
                    // console.log('newindex.')
                    // console.log(JSON.stringify(currentDate[newIndex]))

                    if (JSON.stringify(item) == JSON.stringify(currentDate[newIndex])) {
                        item.state = 1
                        // console.log('si')
                    }
                    newIndex++
                } else {
                    item.state = 0
                }
                return item
                // }
            })

            // console.log('current date')
            // console.log(newDaysPayment)
            let newIndexTwo = 0
            let newDaysPaymentTwo = JSON.parse(daysPaymentTwo).map((item, index) => {
                // if( item.id !== 0 ){
                // console.log()
                // console.log(index)
                if (item.state === 1) {
                    item.state = 1
                } else if (item.state === 0) {
                    if (moment(returnDateFormat(item.date)).format() <= moment(returnDateFormat(currentDate[currentDate.length - 1].date)).format()) {
                        item.state = 1
                    }
                    newIndexTwo++
                } else {
                    item.state = 0
                }
                return item
                // }
            })

            // console.table(newDaysPaymentTwo)
            // return false

            setPreload(true)
            const insertNewDaysPayment = await axios({
                method: 'POST',
                url: process.env.REACT_APP_API + process.env.REACT_APP_UPDATE_DATE_PAYMENT,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { id: getParams.id, newDaysPayment, newDaysPaymentTwo, newDateLock: currentDate[currentDate.length - 1] },
                withCredentials: "true",
                credentials: 'include'
            })
            const resData = insertNewDaysPayment.data
            // console.log(resData)
            if (resData.msg == 'success') {
                setDaysPayment(resData.data.newDaysPayment)
                setDaysPaymentTwo(resData.data.newDaysPaymentTwo)
                // setWrapDaysPayment(resData.data)
                // setDaysPaymentTwo(resData.dataTwo)
                // console.log(resData.dataTwo)
                // setStructureCalendar('1')
                // if (structureCalendar == 0) {
                // setWrapDaysPayment(resData.data)

                setBlockConfirmPay(false)
                setConfirmPay(false)
                setPreload(false)
                // window.rea
                alert(resData.finalized
                    ? 'Pago registrado y crédito finalizado.'
                    : 'Se actualizó las fechas de pago con éxito!')
                location.reload()
            } else {
                alert('Error')
            }
        } else {
            setBlockConfirmPay(false)
            setConfirmPay(false)
        }
    }

    //show popup for payment confirm
    const paymentConfirm = async (eventDate) => {
        // alert('Hola Pago')
        // return false
        // console.log(daysPayment)
        setCurrentDate([])
        const getEventDay = dayjs(eventDate).format("YYYY-MM-DD")
        // console.log(getEventDay)
        // // console.log(JSON.parse(daysPayment))
        // console.log('datossss')
        // console.log(returnDateFormat(eventDate))
        // return false
        // console.log(moment(returnDateFormat(eventDate)).format())
        // console.log(moment(returnDateFormat(el.date)).format())
        const days = JSON.parse(daysPayment) || []
        const daysTwo = JSON.parse(daysPaymentTwo) || []

        const filterReturn = days.filter(
            el => el.state == 0 && moment(returnDateFormat(el.date)).format() <= moment(returnDateFormat(eventDate)).format()
        )
        const mapReturn = days.filter(el => el.state === 0)
        // console.log('fffffff-----')
        // console.log(filterReturn)
        // console.log('ppppp-----')
        // console.log(mapReturn)
        // return false

        if (mapReturn.length === filterReturn.length) { // cuando el cliente pagó todo
            // console.log('map')
            let confirmAllPayment = days.map((el) => {
                return {
                    id: el.id,
                    capital: el.capital,
                    interes: el.interes,
                    amortizacion: el.amortizacion,
                    cuota: el.cuota,
                    comision: el.comision,
                    comision_x_tiempo: el.comision_x_tiempo,
                    cuota_final: el.cuota_final,
                    saldo: el.saldo,
                    lateDate: el.lateDate,
                    date: el.date,
                    state: 1
                }
            })

            let confirmAllPaymentTwo = days.map((el) => {
                return {
                    id: el.id,
                    capital: el.capital,
                    interes: el.interes,
                    amortizacion: el.amortizacion,
                    cuota: el.cuota,
                    comision: el.comision,
                    comision_x_tiempo: el.comision_x_tiempo,
                    cuota_final: el.cuota_final,
                    saldo: el.saldo,
                    lateDate: el.lateDate,
                    date: el.date,
                    state: 1
                }
            })
            // console.log(confirmAllPayment)
            // return false
            setDaysPayment(JSON.stringify(confirmAllPayment))
            setDaysPaymentTwo(JSON.stringify(confirmAllPaymentTwo))
            paymentAll(JSON.stringify(confirmAllPayment), JSON.stringify(confirmAllPaymentTwo))
            return false
        }

        if (filterReturn.length > 0) {
            // console.log('filter')
            // return false
            setBlockConfirmPay(true)
            setCurrentDate(filterReturn)
            // console.log(filterReturn)
            // return false
        }
    }

    const goOutPopup = () => {
        setBlockConfirmPay(false)
        setBlockResquedulePay(false)
    }

    const getStatedevice = async () => {
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_DEVICE_DETAILS
        // console.log(pathApi)
        let dataID = getParams.id

        const stateDevice = await axios({
            method: 'POST',
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                user,
                'Content-Type': 'application/json',
            },
            data: { dataID }
        })
        // console.log(insertCredit)
        const resData = stateDevice.data
        // console.log(resData)
        if (resData.msg == 'exito') {
            // console.log('exito')
            setStateDevice(resData.statusLock)
            setUnlockCode(resData.unlockCode)
        }
    }

    // bloquear dispositivo
    const blockAction = async () => {
        let confirm = window.confirm('¿Confirmar Acción?')
        if (confirm && !stateDevice) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_CONTROL_DEVICE

            let dataID = getParams.id
            let stateBlockDevice = stateDevice

            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { dataID, stateBlockDevice }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'exito') {
                console.log('exito')
                // setStateDevice(stateDevice?false:true)
                setStateDevice(stateDevice ? false : true)
            }
        }
    }

    const overDates = (v, ind) => {
        // console.log(arr)
        // console.log(i)
        let listArr = document.querySelectorAll('.datesPaymentItems')
        // console.log(listArr)
        Array.from(listArr).map(function(ele, index, arr) {
            ele.classList.remove('active');
            // if( ele.classList.contains('select') ){
            for (let i = 0; i <= ind; i++) {
                arr[i].classList.add('active');
                // textActive.innerHTML = states[ind];
            }
            return false
            // }
        })
    }

    const outDates = (v, ind) => {
        // console.log(arr)
        // console.log(i)
        let listArr = document.querySelectorAll('.datesPaymentItems')
        // console.log(listArr)
        Array.from(listArr).map(function(ele, index, arr) {
            ele.classList.remove('active')
            // if( ele.classList.contains('select') ){
            // }
        })
    }

    // Pagar TODO: registra todos los pagos y el backend se encarga de finalizar/desregistrar si corresponde.
    const paymentAll = async (calendarDays, calendarDaysTwo) => {
        const ok = window.confirm('¿Confirmar Pago Total del dispositivo?');
        if (!ok) return;

        try {
            setPreload(true);

            // Enviamos los dos calendarios ya con state=1
            const schedule = JSON.parse(calendarDays || '[]');
            const schedule2 = JSON.parse(calendarDaysTwo || '[]');
            const lastPaid = schedule[schedule.length - 1] || null;

            const { data: res } = await axios({
                method: 'POST',
                url: process.env.REACT_APP_API + process.env.REACT_APP_UPDATE_DATE_PAYMENT,
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                data: {
                    id: getParams.id,
                    newDaysPayment: schedule,
                    newDaysPaymentTwo: schedule2,
                    newDateLock: lastPaid, // compatibilidad con el backend
                    prontoPago: true
                },
                withCredentials: true
            });

            if (res?.msg === 'success') {
                if (res.data?.newDaysPayment) setDaysPayment(res.data.newDaysPayment);
                if (res.data?.newDaysPaymentTwo) setDaysPaymentTwo(res.data.newDaysPaymentTwo);

                alert(res.finalized ? 'Pago total registrado y crédito finalizado.' : 'Pago total registrado.');
                location.reload();
            } else {
                alert('Error al registrar el pago total.');
            }
        } catch (err) {
            console.error(err);
            alert('Error al registrar el pago total.');
        } finally {
            setPreload(false);
        }
    };

    const generateQR = async text => {
        return await QRCode.toDataURL(text, { errorCorrectionLevel: 'H' })
    }

    const changeStructureCalendar = (v) => {
        // console.log(v)
        console.log(structureCalendar)
        setStructureCalendar(v)

        if (structureCalendar == 1) {
            // console.log(daysPaymentTwo)
            // setStructureCalendar(1)
            setWrapDaysPayment(daysPaymentTwo)
            // setStructureCalendar(v)
            console.log('dos')
            // setStructureCalendar(1)
            // return false
        }

        if (structureCalendar == 0) {
            // setStructureCalendar(0)
            setWrapDaysPayment(daysPayment)
            console.log('uno')
            // return false
        }

    }

    const recoverFiles = async () => {
        let confirm = window.confirm('¿Confirmar que desea recuperar los archivos?')
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_RECOVER_FILES
            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { dataID }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                console.log(resData)
            }
        }
    }

    const recoverCartaCobranza = async () => {
        let confirm = window.confirm('¿Generar carta de cobranza?')
        // return false
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_RECOVER_CARTA_COBRANZA
            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { dataID }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                console.log(resData)
                // cartaCobranzaState()
                setCartaCobranzaState(true)
            }
        }
    }

    const recoverConstanciaNoAdeudo = async () => {
        let confirm = window.confirm('¿Generar constancia de no adeudo?')
        // return false
        if (confirm) {
            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_RECOVER_CONTANCIA_NO_ADEUDO
            let dataID = getParams.id
            let stateBlockDevice = stateDevice
            // console.log(days)
            // console.log('franl')
            // return false
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { dataID }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                console.log(resData)
                // cartaCobranzaState()
                // setCartaCobranzaState(true)
                setCartaConstanciaState(true)
            }
        }
    }

    // change Number
    const changeNum = async (e) => {
        let confirm = window.confirm('¿Confirmar cambío de número?')

        if (confirm) {

            if (!refChangeNum.current.value) {
                alert('Error: Ingresar número.')
                return false
            }

            if (refChangeNum.current.value.length != 9) {
                alert('Error: Se solicita 9 digitos.')
                return false
            }

            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_CHANGE_NUM
            let dataID = getParams.id
            let num = refChangeNum.current.value
            let chip = 1

            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { dataID, num, chip }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                // console.log(resData)
                setDataNumbers(resData.dataNumbers)
                let msg = 'SIM 1 EDITADO CON ÉXITO'
                refChangeNum.current.value = ''
                toast.success(msg,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    }
                )
            }
        }
    }

    // change Number
    const changeNumTwo = async (e) => {
        let confirm = window.confirm('¿Confirmar cambío de número?')

        if (confirm) {
            if (!refChangeNumTwo.current.value) {
                alert('Error: Ingresar número en el sim 2.')
                return false
            }

            if (refChangeNumTwo.current.value.length != 9) {
                alert('Error: Se solicita 9 digitos en el sim 2.')
                return false
            }

            let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_CHANGE_NUM
            let dataID = getParams.id
            let num = refChangeNumTwo.current.value
            let chip = 2

            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { dataID, num, chip }
            })
            // console.log(insertCredit)
            const resData = insertCredit.data
            // console.log(resData)
            if (resData.msg == 'success') {
                console.log('exito')
                // console.log(resData)
                setDataNumbers(resData.dataNumbers)
                let msg = 'SIM 2 EDITADO CON ÉXITO'
                refChangeNumTwo.current.value = ''
                toast.success(msg,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    }
                )
            }
        }
    }

    const validateDate = () => {
        try {
            let status = false
            if (daysPayment && daysPayment.length > 10) {
                let feeOne = JSON.parse(daysPayment)[0].cuota_final
                let feeTwo = JSON.parse(daysPayment)[1].cuota_final
                if (feeOne == feeTwo) status = true
            }
            return status
        } catch (e) {
            console.log(e)
        }
    }


    const isDailyCredit = () => {
        return listCreditData && listCreditData.paymentFrequency == 'Diario'
    }

    const getTotalPaymentTimeText = () => {
        if (!listCreditData) return ''

        if (isDailyCredit()) {
            return parseInt(listCreditData.numFee) + ' Días'
        }

        return listCreditData.paymentFrequency == 'Semanal' ?
            listCreditData.numFee / 4 + ' Meses' :
            listCreditData.paymentFrequency == 'Quincenal' ?
                listCreditData.numFee / 2 + ' Meses' :
                listCreditData.numFee / 1 > 1 && validateDate() ?
                    listCreditData.numFee / 1 + ' Meses'
                    : (listCreditData.numFee / 1) - 1 + ' Mes'
    }

    const getPaymentTermText = () => {
        if (!listCreditData) return ''

        if (isDailyCredit()) {
            return parseInt(listCreditData.numFee) + ' Días'
        }

        return (!validateDate()
            ? parseInt(listCreditData.numFee) - 1 + ' '
            : listCreditData.numFee + ' ') +
            (
                listCreditData.paymentFrequency == 'Semanal'
                    ? 'Semanas'
                    : listCreditData.paymentFrequency == 'Quincenal'
                        ? 'Quincenas'
                        :
                        !validateDate()
                            ? 'Mes'
                            : 'Meses'
            )
    }

    const resquedulePayment = (payments) => {
        // console.log(payments)
        setBlockResquedulePay(!blockResquedulePay)
    }

    // const resqueduleNumFeeChange = async () => {
    //     console.log()
    // }

    const doDayResquedule = (num, date) => {
        console.log(date)
        setDayResquedule(date)
        setSelectClassName(num)
    }

    const confirmResquedule = async () => {
        if (dayResquedule == null) {
            alert('Selecciónar fecha a reprogramar.')
            return false
        }
        if (resqueduleNumFeeRef.current.value == null || resqueduleNumFeeRef.current.value == 0) {
            alert('Selecciónar número de cuotas a pagar.')
            return false
        }

        let listPayment = JSON.parse(daysPayment)
        let listPaymentsTrue = listPayment.filter(item => item.state == 1)
        let listPaymentsFalse = listPayment.filter(item => item.state == 0)
        let listPaymentsFalseCount = listPaymentsFalse.length
        let endComplement = []
        // console.log(listPaymentsTrue)
        // console.log('si')
        // console.log(listPaymentsFalse)
        // return false
        // console.log('total de cuotas por pagar')
        let newNumFee = resqueduleNumFeeRef.current.value
        let paymentFrequency = listCreditData.paymentFrequency
        // return false

        if (paymentFrequency == 'Semanal') {
            let numDays = 7
            for (let i = 1; i <= listPaymentsFalse.length; i++) {
                let setWeeksDays = moment(returnDateFormatTwo(dayResquedule)).add(i * numDays, 'days')
                let weeksDays = setWeeksDays.format('DD/MM/YYYY')

                listPaymentsFalse[i - 1].date = weeksDays
                listPaymentsFalse[i - 1].state = 0

                if (i - 1 <= newNumFee - 1) {
                    listPaymentsFalse[i - 1].state = 1
                }
            }
            // console.log('mm')
            endComplement = listPaymentsFalse.filter((el, i) => el.date = moment(returnDateFormat(el.date)).subtract(1 * numDays, 'days').format('DD/MM/YYYY'))
            // console.log(restListPaymentFalse)

        } else if (paymentFrequency == 'Quincenal') {
            let numDays = 15
            for (let i = 1; i <= listPaymentsFalse.length; i++) {
                let setWeeksDays = moment(returnDateFormatTwo(dayResquedule)).add(i * numDays, 'days')
                let weeksDays = setWeeksDays.format('DD/MM/YYYY')

                listPaymentsFalse[i - 1].date = weeksDays
                listPaymentsFalse[i - 1].state = 0

                if (i - 1 <= newNumFee - 1) {
                    listPaymentsFalse[i - 1].state = 1
                }
            }
            endComplement = listPaymentsFalse.filter((el, i) => el.date = moment(returnDateFormat(el.date)).subtract(1 * numDays, 'days').format('DD/MM/YYYY'))
        } else {

        }

        // console.log('abcdefg')
        // console.log(newNumFee)
        let newDateLock = listPaymentsFalse[parseInt(newNumFee) - 1]

        let newDaysPayment = listPaymentsTrue.concat(endComplement)
        console.log('CRONOGRAMA DE CRÉDITO')
        console.log(newDaysPayment)
        // return false
        let confirm = window.confirm('¿Confirmar Reprogramación de calendario?')
        let newIndex = 0
        // console.log(daysPayment)
        // return false
        if (confirm) {
            setPreload(true)
            const insertNewDaysPayment = await axios({
                method: 'POST',
                url: process.env.REACT_APP_API + process.env.REACT_APP_RESCHEDULING_PAYMENTS,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                data: { id: getParams.id, newDaysPayment, listPaymentsFalseCount, newDateLock }
            })
            const resData = insertNewDaysPayment.data
            // console.log(resData)
            if (resData.msg == 'success') {
                setDaysPayment(resData.data.newDaysPayment)
                // setDaysPaymentTwo(resData.data.newDaysPaymentTwo)
                setPreload(false)
                setBlockResquedulePay(false)
                // window.rea
                alert('Se reprogramó las fechas de pagó con éxito!')
                location.reload()
            } else {
                alert('Error')
            }
        } else {
            setBlockResquedulePay(false)
        }
    }

    useEffect(() => {
        changeEventsCalendar()
    }, [daysPayment])


    useEffect(() => {
        getCreditData()
        getCobranzasUsers()
        getStatedevice()
    }, [])


    useEffect(() => {
        // console.log(payNow)
        if (listCreditDataLocation) {
            if (listCreditDataLocation.lat && listCreditDataLocation.lon) {
                window.initMap = () => {
                    const myLatlng = { lat: parseFloat(listCreditDataLocation.lat), lng: parseFloat(listCreditDataLocation.lon) }
                    const map = new google.maps.Map(document.getElementById("map"), {
                        zoom: 18,
                        center: myLatlng,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    })

                    let addMarker = new google.maps.Marker({
                        position: myLatlng,
                        map: map,
                        // icon: {
                        //     url: "http://127.0.0.1:5500/movilpay/get-location/marker.png",
                        //     size: new google.maps.Size(50, 42)
                        // }
                    })
                }
            }
        }
    }, [listCreditDataLocation])



    return (
        <div>
            {
                preload && (
                    <PreloadFetch />
                )
            }
            <ScrollToTop />
            <Header user={user} namePage={props.namePage} />
            <section className="sectionBody sectionBodyCredit">
                <div className="containerCustom containerBody">
                    {
                        listCreditData && (
                            <div className="blockBody">
                                <h3>{listCreditData.fullName + ' ' + listCreditData.lastName}</h3>
                                <div className="parentData parentDataFirst">

                                    {['1', '4'].includes(userRole) && (
                                        <div className="blockLoanCalculation">
                                            <h3 className="fs-5">RESPONSABLE DE CRÉDITOS Y COBRANZAS:</h3>
                                            <div style={{ marginTop: 12 }}>
                                                <span className="loadTitle" style={{ display: 'block', marginBottom: 6 }}>Responsable (Créditos y Cobranzas):</span>
                                                <Select
                                                    classNamePrefix="rs"
                                                    isLoading={loadingCobranzasUsers}
                                                    isDisabled={cobranzasLocked}
                                                    placeholder="Selecciona a una persona..."
                                                    options={cobranzasUsers}
                                                    value={cobranzasSelected}
                                                    onChange={(opt) => assignCobranzasUser(opt)}
                                                    isClearable={false}
                                                />
                                                {cobranzasLocked && (
                                                    <small style={{ display: 'block', marginTop: 6, opacity: 0.75 }}>
                                                        Asignado: {listCreditData?.cobranzaUserName || cobranzasSelected?.label}. (Solo se puede asignar una vez)
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN DEL ASESOR:</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Nombre:</span>
                                                <span className="loanPrice">{listCreditData.advisorFirstName}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Sede:</span>
                                                <span className="loanPrice">{listCreditData.sedeName}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN PERSONAL:</h3>

                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Nombre Completo:</span>
                                                <span className="loanPrice">{listCreditData.fullName + ' ' + listCreditData.lastName}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Documento de Identidad:</span>
                                                <span className="loanPrice">{listCreditData.dni}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Email:</span>
                                                <span className="loanPrice">{listCreditData.email}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Número de Celular:</span>
                                                <span className="loanPrice">{listCreditData.phoneNumber}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Estado civil:</span>
                                                <span className="loanPrice">{listCreditData.civilStatus}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Número de Dependientes:</span>
                                                <span className="loanPrice">{listCreditData.dependents}</span>
                                            </div>

                                            <div>
                                                <div className="parentDniBlock">
                                                    <span className="loadTitle">DNI parte frontal:</span>
                                                    <span className="loanPrice parentDni"><img src={process.env.REACT_APP_API + '/data-files/' + listCreditData.uploadName + '/' + listCreditData.dniFront} /></span>
                                                </div>
                                                <div className="parentDniBlock">
                                                    <span className="loadTitle">DNI parte trasera:</span>
                                                    <span className="loanPrice parentDni"><img src={process.env.REACT_APP_API + '/data-files/' + listCreditData.uploadName + '/' + listCreditData.dniBack} /></span>
                                                </div>
                                            </div>

                                            <div className="parentDniBlock">
                                                <span className="loadTitle">Video del cliente:</span>
                                                <span className="loanPrice parentDni">
                                                    <video className="creditVideoFace" src={process.env.REACT_APP_API + '/data-files/' + listCreditData.uploadName + '/' + listCreditData.clientVideo} controls={true} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN DEL EQUIPO:</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Device ID:</span>
                                                <span className="loanPrice">{listCreditData.deviceID}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Fecha de contrato:</span>
                                                <span className="loanPrice">{listCreditData.contractDate}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Nombre del Equipo:</span>
                                                <span className="loanPrice">{listCreditData.phoneName}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">IMEI:</span>
                                                <span className="loanPrice">{listCreditData.imei}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Precio del Equipo:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.phonePrice).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Porcentaje Inicial:</span>
                                                <span className="loanPrice">%{listCreditData.initialPercent}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Precio Inicial:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.initialPrice).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Frecuencia de Pago:</span>
                                                <span className="loanPrice">{listCreditData.paymentFrequency}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Número de Pagos:</span>
                                                <span className="loanPrice">{listCreditData.numFee}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Tiempo total de pagó:</span>
                                                <span className="loanPrice">{getTotalPaymentTimeText()}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Monto Financiado:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.amountFinance).toFixed(2)}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Monto Total a pagar del Financiamiento:</span>
                                                <span className="loanPrice">S/ {parseFloat(listCreditData.totalAmountFinance).toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN LABORAL Y FINANCIERA:</h3>
                                        <div className="listLoanCalculation">

                                            <div>
                                                <span className="loadTitle">Tipo de Trabajo:</span>
                                                <span className="loanPrice">{listCreditData.jobType}</span>
                                            </div>

                                            <div>
                                                <span className="loadTitle">Nombre de Trabajo:</span>
                                                <span className="loanPrice">{listCreditData.jobName}</span>
                                            </div>

                                            <div>
                                                <span className="loadTitle">Dirección de Trabajo:</span>
                                                <span className="loanPrice">{listCreditData.jobDirec}</span>
                                            </div>

                                            {/* <div>
                                                <span className="loadTitle">Nota de Trabajo:</span>
                                                <span className="loanPrice">{listCreditData.jobNote}</span>
                                            </div> */}

                                            <div>
                                                <span className="loadTitle">Tiene tarjeta de Crédito:</span>
                                                <span className="loanPrice">{listCreditData.creditCard}</span>
                                            </div>

                                            <div>
                                                <span className="loadTitle">Ingresos al Mes:</span>
                                                <span className="loanPrice">S/ {listCreditData.monthIncome}</span>
                                            </div>

                                            <div>
                                                <span className="loadTitle">Gastos al Mes:</span>
                                                <span className="loanPrice">S/ {listCreditData.monthlyExpenses}</span>
                                            </div>

                                            <div>
                                                <span className="loadTitle">Record Créditicio:</span>
                                                <span className="loanPrice">{listCreditData.creditRecord} Puntos</span>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="blockLoanCalculation">
                                        <h3 className="fs-5">INFORMACIÓN DE UBICACIÓN Y DIRECCIÓN:</h3>
                                        <div className="listLoanCalculation">
                                            <div>
                                                <span className="loadTitle">Dirección:</span>
                                                <span className="loanPrice">{listCreditData.location}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Número de casa o departamento:</span>
                                                <span className="loanPrice">{listCreditData.locationNumber}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Tipo de vivienda:</span>
                                                <span className="loanPrice">{listCreditData.livingPlace}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Departamento:</span>
                                                <span className="loanPrice">{listCreditData.department}</span>
                                            </div>
                                            <div>
                                                <span className="loadTitle">Ciudad:</span>
                                                <span className="loanPrice">{listCreditData.city}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {
                                    listCreditDataLocation && (
                                        <>
                                            <div className="blockLocationData">
                                                <h3 className="fs-5">INFORMACIÓN DE UBICACIÓN DEL CLIENTE:</h3>
                                                <div className="listLoanCalculation">
                                                    <div>
                                                        <span className="loadTitle">Dirección:</span>
                                                        <span className="loanPrice">{listCreditDataLocation.direc}</span>
                                                    </div>
                                                    <div>
                                                        <span className="loadTitle">Referencia:</span>
                                                        <span className="loanPrice">{listCreditDataLocation.refer}</span>
                                                    </div>
                                                    <div className="parentDniBlock">
                                                        <span className="loadTitle">Imagen de casa del cliente:</span>
                                                        <span className="loanPrice parentDni">
                                                            <img src={process.env.REACT_APP_API + '/data-files/' + listCreditData.uploadName + '/' + listCreditDataLocation.image} alt="Location Image" />
                                                            <img src={process.env.REACT_APP_API + '/data-files/' + listCreditData.uploadName + '/' + listCreditDataLocation.imageTwo} alt="Location Image two" />
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="blockLocationData">
                                                <h3 className="fs-5">MAPA UBICACIÓN DEL CLIENTE:</h3>

                                                <div className="defaultTextLocation">
                                                    <input value={`https://maps.google.com/maps?q=${listCreditDataLocation.lat},${listCreditDataLocation.lon}&hl=es&z=18&amp;output=embed`} readOnly />
                                                </div>

                                                <div className="parentGoogleMaps">
                                                    <>
                                                        <Helmet>
                                                            <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB45Nmo8iuOJRcu2pbjlWUkS4tJfHnffA8&callback=initMap&v=weekly" async defer />
                                                        </Helmet>
                                                        <div style={{ height: "100%" }} id="map"></div>
                                                    </>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }

                                <div className="controlBarWrapper">
                                    <div className="controlBar">
                                        <h3>RECOVER CONTRACT FILE</h3>
                                        <div>
                                            <button onClick={recoverFiles} className="controlBarButtonAction controlBarButtonActionActive">RECOVER FILES</button>
                                        </div>
                                    </div>
                                </div>

                                {
                                    stateBlockDevice == '3' && (
                                        <div className="controlBarWrapper">
                                            <div className="controlBar">
                                                <h3>CONSTANCIA DE NO ADEUDO</h3>
                                                {/* <div>
                                                    <a href={uploadName} download={true} target="_blank" className="controlBarButtonAction controlBarButtonActionActive">GENERAR CONSTANCIA</a>
                                                </div> */}

                                                <div>
                                                    <button onClick={recoverConstanciaNoAdeudo} className="controlBarButtonAction controlBarButtonActionActive">GENERAR CONSTANCIA</button>
                                                    {
                                                        cartaConstanciaState && (
                                                            <a href={uploadName} download={true} target="_blank" className="controlBarButtonAction controlBarButtonActionActive">DESCARGAR</a>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    stateFilter == 3 && (
                                        <div className="controlBarWrapper controlCobranza">
                                            <div className="controlBar">
                                                <h3>CARTA DE COBRANZA</h3>
                                                <div>
                                                    <button onClick={recoverCartaCobranza} className="controlBarButtonAction controlBarButtonActionActive">GENERAR CARTA</button>
                                                    {
                                                        cartaCobranzaState && (
                                                            <a href={uploadNameCartaCobranza} download={true} target="_blank" className="controlBarButtonAction controlBarButtonActionActive">DESCARGAR</a>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="controlBarWrapper">
                                    <div className="controlBar">
                                        <h3>BARRA DE CONTROL DEL DISPOSITIVO</h3>
                                        <div className="controlBarBox">
                                            {/* <div>Estado del dispositivo:  <strong>{stateDevice? 'BLOQUEADO' : 'ACTIVO'}</strong></div>
                                            <div onClick={blockAction} className={!stateDevice ? 'controlBarButtonAction controlBarButtonActionActive' : 'controlBarButtonAction controlBarButtonActionBlock'}>{!stateDevice ? 'BLOQUEAR DISPOSITIVO' : 'ACTIVAR DISPOSITIVO'}</div> */}

                                            {
                                                listCreditData.stateBlockDevice === '3' ?
                                                    <div>Estado del dispositivo:  <strong>FINALIZADO</strong></div>
                                                    :
                                                    <>
                                                        <div>Estado del dispositivo:  <strong>{stateDevice ? 'BLOQUEADO' : 'ACTIVO'}</strong></div>
                                                        <div onClick={blockAction} className={!stateDevice ? 'controlBarButtonAction controlBarButtonActionActive' : 'controlBarButtonAction controlBarButtonActionBlock'}>{!stateDevice ? 'BLOQUEAR DISPOSITIVO' : 'DISPOSITIVO BLOQUEADO'}</div>
                                                    </>
                                            }
                                        </div>

                                        {/* <h3>BARRA DE CONTROL DEL DISPOSITIVO</h3> */}
                                        {
                                            listCreditData.stateBlockDevice !== '3' && unlockCode && (
                                                <div className="controlBarBox sectionOfflineCode">
                                                    <div>Código de desbloqueo Offline:  <strong>{unlockCode}</strong></div>
                                                </div>
                                            )
                                        }

                                        {
                                            listCreditData.stateBlockDevice !== '3' && urlQrCode && (
                                                <div className="sectionQrcode">
                                                    <div><strong>QR de Enrolamiento:</strong></div>
                                                    <img src={urlQrCode} />
                                                </div>
                                            )
                                        }

                                        {
                                            listCreditData.stateBlockDevice != '3' && (
                                                <div className="sectionChangeNum">
                                                    <h3>CAMBIO DE NÚMERO</h3>
                                                    <div className="sectionChangeNumBody">
                                                        <div className="boxChangeNum">
                                                            <h3><strong>Historial de cambios</strong></h3>
                                                            {
                                                                dataNumbers && dataNumbers.map((item, index) => {
                                                                    let months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
                                                                    let splitMonthString = item.num_date.split('T')
                                                                    let getDayMonth = splitMonthString[0].split('-')[1]
                                                                    let getDayNum = splitMonthString[0].split('-')[2]
                                                                    let getYearNum = splitMonthString[0].split('-')[0]
                                                                    // console.log(splitMonthString[0].split('-')[2])
                                                                    // console.log(getYearNum)
                                                                    return <div key={index} className="boxChangeNumOne">
                                                                        <span>{index + 1}. {getDayNum} de {months[parseInt(getDayMonth) - 1]} del {getYearNum} de </span>
                                                                        <div>{item.num_last_num}</div>
                                                                        <span> A </span>
                                                                        <div>{item.num_new_num}</div>
                                                                        <span>en SIM {item.num_chip}</span>
                                                                    </div>
                                                                })
                                                            }
                                                            {
                                                                dataNumbers && dataNumbers.length === 0 && (
                                                                    <div className="boxChangeNumOne">
                                                                        <div>No hay resultados</div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>

                                                        <p className="changeNumWarning">Advertencia: El chip nuevo debe estar ingresado en el equipo.</p>
                                                        <div className="boxesChangeNum">
                                                            <div className="boxChangeNumAdd">
                                                                <h3><strong>SIM 1</strong></h3>
                                                                <input
                                                                    type="text"
                                                                    ref={refChangeNum}
                                                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]+/ig, '').substring(0, 9)}
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                />
                                                                <div className="btnAddNum" onClick={(e) => changeNum(e)}>Guardar</div>
                                                            </div>

                                                            <div className="boxChangeNumAdd boxChangeNumAddTwo">
                                                                <h3><strong>SIM 2</strong></h3>
                                                                <input
                                                                    type="text"
                                                                    ref={refChangeNumTwo}
                                                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]+/ig, '').substring(0, 9)}
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                />
                                                                <div className="btnAddNum" onClick={(e) => changeNumTwo(e)}>Guardar</div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        }

                                    </div>
                                </div>


                                <div className="parentCalendar">
                                    <h3 className="fs-5 titleCalendar">CALENDARIO DE PAGOS:</h3>

                                    {/* <ReactFullYearScheduler
                                        events={events}
                                        locale="es"
                                        dateTooltipTheme="material"
                                        weekSeparatorWidth={10}
                                        weekSeparatorColor="white"
                                        headerWeekDayBgColor="#b39cd0"
                                        headerWeekendBgColor="rgba(75, 68, 83, 0.69)"
                                        weekendCellBackgroundColor="rgba(75, 68, 83, 0.69)"
                                        weekendCellTextColor="white"
                                        weekDayCellBackgroundColor="rgba(75, 68, 83, 0.69)"
                                        weekDayCellTextColor="white"
                                        selectionColor="black"
                                        selectionTextColor="white"
                                        maxRangeSelection={0}
                                        minRangeSelection={0}
                                        firstDayOfWeek="Monday"
                                        maxYear={new Date().getFullYear() + 1}
                                        minYear={new Date().getFullYear()}
                                        readonlyCalendar={false}
                                        showWeekSeparator={true}
                                        showTodayButton={true}
                                        enableYearToYearSelection={false}
                                        enableWeekendSelection={true}
                                        minCellWidth={50}
                                        showSeparatorInHeader={false}
                                        enableEventOverwriting={true}
                                        onDatePick={(eventDate, clearSelectedCell) => {
                                            // console.log(dayjs(eventDate.toDate()).format("YYYY-MM-DD"))
                                            // console.log(daysPayment)

                                            const getEventDay = dayjs(eventDate.toDate()).format("YYYY-MM-DD")
                                            const days = JSON.parse(daysPayment) || []
                                            const filterReturn = days.filter(el => el.state === 0 && el.date === getEventDay)
                                            // console.log(filterReturn)

                                            if (filterReturn.length > 0) {
                                                setBlockConfirmPay(true)
                                                setCurrentDate(dayjs(eventDate.toDate()).format("YYYY-MM-DD"))
                                            }

                                            setTimeout(() => {
                                                clearSelectedCell()
                                            }, 1000)
                                        }}
                                        // onEventSinglePickInterception={(date, eventName, clearSelectedCell) => {
                                        //     console.table([eventName, date.toDate()]);
                                        // }}
                                        onRangePick={(
                                            eventStartDate,
                                            eventEndDate,
                                            clearSecondSelectedCell,
                                            clearSelection
                                        ) => {
                                            setTimeout(() => {
                                                clearSelection();
                                            }, 500);
                                        }}

                                        onEventRangePickInterception={(
                                            eventFirstDate,
                                            eventLastDate,
                                            eventsToBeDeleted,
                                            eventsToBeUpdated,
                                            clearSecondSelectedCell,
                                            clearSelection
                                        ) => {
                                            setTimeout(() => {
                                                clearSelection();
                                            }, 500);
                                        }}
                                    /> */}
                                </div>

                                {
                                    resumePayment && resumePayment.length > 0 && (
                                        <div className="parentData resumePayment">
                                            <div>
                                                <h3 className="fs-5 titleDatePayment">RESUMEN DE PAGOS</h3>

                                                <div className="listLoanCalculation datesPayments datesPaymentsHead">
                                                    <div className="tableFinancialHead">
                                                        <span>CUOTA</span>
                                                        <span>SELLER</span>
                                                        <span>CANTIDAD DE CUOTAS</span>
                                                        <span>MONTO DE CUOTA</span>
                                                        <span>FECHA VENCIMIENTO</span>
                                                        <span>FECHA PAGÓ</span>
                                                    </div>
                                                </div>

                                                <div className="listLoanCalculation datesPayments WrapperDatesPayments">
                                                    {
                                                        resumePayment && resumePayment.map((item, index) => {
                                                            const nFees = Number(item?.fr_num_fee_paid || 1);
                                                            const isProntoPago = nFees > 1;

                                                            // Monto real pagado registrado en fp_payments.fr_fee
                                                            const paidFee = Number(item?.fr_fee ?? 0);

                                                            // Fallback por si algún registro viejo no trae fr_fee
                                                            let fallbackCuota = 0;
                                                            try {
                                                                const dp = JSON.parse(wrapDaysPayment || "[]");
                                                                fallbackCuota = Number(dp?.[0]?.cuota_final ?? dp?.[0]?.cuota ?? 0);
                                                            } catch {}

                                                            const feeToShow = paidFee > 0 ? paidFee : fallbackCuota;

                                                            return (
                                                                <div key={index}>
                                                                    <span>{index + 1}</span>
                                                                    <span>{item?.seller_name || "-"}</span>

                                                                    <span>
                                                                        {isProntoPago ? `${nFees}` : "1"}
                                                                    </span>

                                                                    <span className="loanPrice">
                                                                        S/ {Number(feeToShow).toFixed(2)}
                                                                    </span>

                                                                    <span>{item?.fr_expire}</span>
                                                                    <span>{item?.fr_current_date}</span>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>

                                                <div className="resumePaymentDetail">
                                                    CANTIDAD DE CUOTAS: <strong>{feeCount}</strong> |
                                                    CUOTAS PAGADAS: <strong>{feePay}</strong> |
                                                    CUOTAS VENCIDAS: <strong>{feeExpire}</strong> |
                                                    CUOTAS PENDIENTES: <strong>{feePendingTotal}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="parentData">
                                    <div>
                                        <h3 className="fs-5 titleDatePayment">FECHAS DE PAGO</h3>

                                        <div className="financialCreditData">
                                            <div>
                                                <div className="itemSigno">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Financiamiento</span>
                                                    <span className="itemTwo">{listCreditData.amountFinance.toFixed(2)}</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="itemSigno itemHeadDate">
                                                    <ImCalendar />
                                                </div>
                                                <div className="itemData">
                                                    <span className="itemOne">Plazo</span>
                                                    <span className="itemTwo">{getPaymentTermText()}</span>
                                                </div>
                                            </div>
                                            {/* <div>
                                                <div className="itemSigno itemComision">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Comisión Tecnológica</span>
                                                    <span className="itemTwo">{(100).toFixed(2)}</span>
                                                </div>
                                            </div> */}
                                            <div>
                                                <div className="itemSigno itemTotalAmount2">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Monto Actual a pagar</span>
                                                    <span className="itemTwo">{payNow}</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="itemSigno itemTotalAmount">S/.</div>
                                                <div className="itemData">
                                                    <span className="itemOne">Total a pagar</span>
                                                    <span className="itemTwo">{(listCreditData.totalAmountFinance).toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </div>


                                        {
                                            localStorage.getItem('user') !== 'creditosycobranzas.movilpro@gmail.com' ?
                                                <div className="buttonsChangeTime">
                                                    <div onClick={() => changeStructureCalendar(0)} className={structureCalendar == 0 ? 'select' : ''}>{listCreditData.paymentFrequency}</div>
                                                    <div onClick={() => changeStructureCalendar(1)} className={structureCalendar == 1 ? 'select' : ''}>Diario</div>
                                                </div>
                                                :
                                                <div className="buttonsChangeTime">
                                                    <div className={structureCalendar == 0 ? 'select' : ''}>{listCreditData.paymentFrequency}</div>
                                                    <div className={structureCalendar == 1 ? 'select' : ''}>Diario</div>
                                                </div>
                                        }


                                        <div className="listLoanCalculation datesPayments datesPaymentsHead">
                                            <div className="tableFinancialHead">
                                                <span>#</span>
                                                <span>ESTADO</span>
                                                <span>VENCIMIENTO</span>
                                                <span>CAPITAL</span>
                                                <span>INTERES</span>
                                                <span>AMORTIZACIÓN</span>
                                                <span>COMISION</span>
                                                <span>COMISION 2</span>
                                                <span>CUOTA</span>
                                                <span>SALDO</span>
                                            </div>
                                        </div>
                                        <div className="listLoanCalculation datesPayments WrapperDatesPayments">


                                            <div>
                                                <span>#</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>S/ {parseFloat(listCreditData.amountFinance).toFixed(2)}</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>---</span>
                                                <span>S/ {parseFloat(listCreditData.amountFinance).toFixed(2)}</span>
                                            </div>


                                            {
                                                wrapDaysPayment && JSON.parse(wrapDaysPayment).map((item, index, arr) => {
                                                    // console.log(item)
                                                    // if( item.id !== 0 ){
                                                    let styleComision = {}
                                                    let selectItem = ''
                                                    let comision2State = ''

                                                    if (item.id !== 0) {
                                                        if (item.comision !== '' && item.comision != null) {
                                                            styleComision = { backgroundColor: 'lightgreen', fontWeight: 700 }
                                                        }

                                                        if (
                                                            item.state === 0 &&
                                                            moment(returnDateFormat(item.date)).isSame(moment().format("YYYY-MM-DD"))
                                                            || moment(moment().format("YYYY-MM-DD")).isAfter(returnDateFormat(item.date))) {
                                                            selectItem = 'select'
                                                        }

                                                        if (item.date == moment().format("DD/MM/YYYY")) {
                                                            selectItem = 'select now'
                                                        }
                                                    }

                                                    return <div
                                                        className={"datesPaymentItems " + selectItem}
                                                        key={index}
                                                        onMouseOut={(event) => outDates(event.target, index)}
                                                        onMouseOver={(event) => overDates(event.target, index)}>
                                                        <span>{index + 1 + '.'}</span>
                                                        {
                                                            item.state === 0 && item.date !== null && (
                                                                // <span className="loanPrice htmlPaymentState" onClick={() => structureCalendar == 0 ? paymentConfirm(item.date) : alert('Accción no permitido')}><strong>PENDIENTE</strong></span>
                                                                <span className="loanPrice htmlPaymentState"><strong>PENDIENTE</strong></span>
                                                            )
                                                        }
                                                        {
                                                            item.state == 1 && item.date !== null && (
                                                                <span className="loanPrice htmlPaymentState htmlPaymentState1"><strong>CANCELADO</strong></span>
                                                            )
                                                        }
                                                        {
                                                            item.state == 0 && item.date == null && (
                                                                <span>---</span>
                                                            )
                                                        }
                                                        <span className="loadTitle">{item.date == null ? '---' : item.date}</span>
                                                        <span>{item.capital == null ? '---' : 'S/ ' + parseFloat(item.capital).toFixed(2)}</span>
                                                        <span>{item.interes == null ? '---' : 'S/ ' + parseFloat(item.interes).toFixed(2)}</span>
                                                        <span>{item.amortizacion == null ? '---' : 'S/ ' + parseFloat(item.amortizacion).toFixed(2)}</span>
                                                        <span style={styleComision}>{item.comision == null ? '---' : 'S/ ' + parseFloat(item.comision).toFixed(2)}</span>
                                                        <span className={comision2State}>{item.comision_x_tiempo == null ? '---' : 'S/ ' + parseFloat(item.comision_x_tiempo).toFixed(2)}</span>
                                                        <span className="loanPrice">{item.cuota_final == null ? '---' : 'S/ ' + parseFloat(item.cuota_final).toFixed(2)}</span>
                                                        <span>S/ {parseFloat(item.saldo).toFixed(2)}</span>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>

                                {
                                    listCreditData.stateBlockDevice !== '3' && (
                                        <>
                                            <button className="btn btn-lg btn-success btnPayAll" onClick={(e) => paymentConfirm(JSON.parse(daysPayment)[JSON.parse(daysPayment).length - 1].date)}>Pagar Todo</button>
                                        </>
                                    )
                                }

                                {
                                    listResPayments && listResPayments.length > 0 && (
                                        <div className="parentData resumePayment resumeRepro">
                                            <div>
                                                <h3 className="fs-5 titleDatePayment">RESUMEN DE REPROGRAMACIÓNES</h3>

                                                <div className="listLoanCalculation datesPayments datesPaymentsHead">
                                                    <div className="tableFinancialHead">
                                                        <span>ID</span>
                                                        <span>CUOTAS ATRASADAS</span>
                                                        <span>FECHA DE REPROGRAMACIÓN</span>
                                                        <span>CONTRATO</span>
                                                    </div>
                                                </div>

                                                <div className="listLoanCalculation datesPayments WrapperDatesPayments">
                                                    {
                                                        listResPayments && listResPayments.map((item, index, arr) => {
                                                            return <div
                                                                key={index}>
                                                                <span>{index + 1}</span>
                                                                <span>{item.rp_late_fees}</span>
                                                                <span>{item.rp_date}</span>
                                                                <span>{'FILE'}</span>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {/* {
                                    listCreditData.stateBlockDevice !== '3' && (
                                        <>
                                            {
                                                countPaymentFalse.length && (
                                                    <button className="btn btn-lg btn-success btnPayAll" onClick={(e) => resquedulePayment(JSON.parse(daysPayment))}>Reprogramar Calendario</button>
                                                )
                                            }
                                        </>
                                    )
                                } */}
                            </div>
                        )
                    }
                </div>
            </section>
            {
                blockConfirmPay && (
                    <div className="popupConfirmPayment">
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupGoOut" onClick={() => goOutPopup()}><ImCross /></div>
                            <div className="popupConfirmPayment_content">
                                <h4>Confirmar Pago</h4>
                                <h5 className="popupConfirmPayment_subtitle">Al hacer click en el cuadro estas confirmando la verificación del pago.</h5>

                                <div className="checkConfirmPay" onClick={(e) => setConfirmPay(true)}>
                                    {
                                        confirmPay && (
                                            <div><ImCheckmark /></div>
                                        )
                                    }
                                </div>
                                <button className="buttonConfirmPay" onClick={confirmChangePay} >Confirmar</button>
                            </div>
                        </div>
                    </div>
                )
            }
            <Footer />

            {
                blockResquedulePay && (
                    <div className="popupConfirmPayment">
                        <div className="popupConfirmPayment_wrapper">
                            <div className="popupGoOut" onClick={() => goOutPopup()}><ImCross /></div>

                            <div className="popupConfirmPayment_content">
                                <h4>Confirmar Reprogramación de Pago</h4>
                                <h5 className="popupConfirmPayment_subtitle">Selecciónar día para reprogramación del calendario:</h5>

                                <div className="resqueduleDaysList">
                                    <div className={selectClassName == 0 ? 'active' : ''} onClick={() => doDayResquedule(0, moment().format("DD-MM-YYYY"))}>
                                        {moment().format("DD-MM-YYYY")} - <span>Hoy</span>
                                    </div>
                                    <div className={selectClassName == 1 ? 'active' : ''} onClick={() => doDayResquedule(1, moment().add(1, 'days').format("DD-MM-YYYY"))}>
                                        {moment().add(1, 'days').format("DD-MM-YYYY")} - <span>{moment().add(1, 'days').format('dddd')}</span>
                                    </div>
                                </div>

                                <h5 className="popupConfirmPayment_subtitle">Selecciónar número de cuotas a pagar:</h5>

                                <div className="resqueduleDaysList">
                                    <select
                                        // onChange={(e) => resqueduleNumFeeChange(e)}
                                        // options={paymentFrequencyArr}
                                        // autoFocus={true}
                                        className="selectForm formItem selectResNumFee"
                                        name=""
                                        id="paymentFrequency"
                                        ref={resqueduleNumFeeRef}
                                    >
                                        {
                                            countPaymentFalse.map((item, index) => {
                                                // console.log(item)
                                                return <option key={'fp' + index} value={item}>{item}</option>
                                            })
                                        }
                                    </select>
                                </div>

                                <button className="buttonConfirmPay" onClick={confirmResquedule}>Confirmar</button>
                            </div>

                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default CreditPage
